import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";

import Analytics from "js/analytics";
import { Button } from "js/Components/Button";
import { getStaticUrl } from "js/config";
import { BeautifulDialog, ShowDialog } from "js/react/components/Dialogs/BaseDialog";
import { Gap10 } from "js/react/components/Gap";
import { FlexBox } from "js/react/components/LayoutGrid";
import { themeColors } from "js/react/sharedStyles";

import { DialogActions, DialogBody, DialogContent, DialogTitle, NeedHelp, UpgradeToRestoreSection } from "./components/DialogComponents";

const StyledDialogContent = styled(DialogContent)`
    &&& {
        gap: 5px;
    }
`;

const StyledDialogActions = styled(DialogActions)`
    &&& {
        justify-content: space-between;
    }
`;

function SubscriptionCanceledDialog(props: { onClose: () => void, voluntaryCancellation: boolean }) {
    const { onClose, voluntaryCancellation } = props;
    const { t } = useTranslation();

    useEffect(() => {
        Analytics.Dunning.SubscriptionCanceledDialogOpened();
    }, []);

    const handleUpgrade = async () => {
        Analytics.Dunning.SubscriptionCanceledDialogUpgradeClicked();

        // @ts-ignore
        const { default: ChangePlanDialog } = await import("js/react/components/Dialogs/ChangePlanDialog");
        ShowDialog(ChangePlanDialog, {
            analytics: { cta: "subscription_canceled_dialog_upgrade" }
        });

        onClose();
    };

    const handleContinueOnBasic = async () => {
        Analytics.Dunning.SubscriptionCanceledDialogDismissed();
        onClose();
    };

    return (
        <BeautifulDialog preventClose>
            <DialogBody>
                <DialogTitle>
                    <img src={getStaticUrl("/images/beautifulai-logos/beautifulai-logo-round.svg")} />
                    <Gap10 />
                    <div>{voluntaryCancellation ? t("Your subscription has been canceled") : t("We couldn't process your payment")}</div>
                    <p>{t("Your subscription has been canceled, but your presentations and content are right where you left them. Upgrade anytime to restore premium features.")}</p>
                </DialogTitle>
                <StyledDialogContent>
                    <UpgradeToRestoreSection />
                </StyledDialogContent>
                <StyledDialogActions>
                    <NeedHelp />
                    <FlexBox gap={20} wrap>
                        <Button onClick={handleContinueOnBasic} large color={themeColors.lightGray} style={{ color: "#666" }}>
                            {t("Continue on Basic")}
                        </Button>
                        <Button upgrade large onClick={handleUpgrade}>
                            {t("Upgrade")}
                        </Button>
                    </FlexBox>
                </StyledDialogActions>
            </DialogBody>
        </BeautifulDialog>
    );
}

export default SubscriptionCanceledDialog;
